<template lang='pug'>
  v-container
    v-row(justify='center' align='center').contact-form
      v-col(cols='10'  lg='6')
        h1.display-1.grey--text.text--darken-2 Contact Us
        v-divider.spaced-divider
        form#contactForm(v-on:submit.prevent='sendContact')
          v-text-field(label='Email' v-model='email' type='email' required)
          v-textarea(name='comments' v-model='comments' label='Questions, Comments, Poems, Existential-Musings' textarea outlined required)
          v-row.pa-2
            .caption.grey--text.darken-2 Or you can email us at&nbsp;
              a(href='mailto:hello@bionicmetrics.com') hello@bionicmetrics.com
            v-spacer
            v-btn(color='cyan lighten-1' :loading='loading' dark type='submit') Submit
</template>

<script>
import System from '../api/system';
import Notifications from '../services/notification.service';


export default {
  name: 'Contact',
  data() {
    return {
      loading: false,
      email: null,
      comments: null
    };
  },
  methods: {
    clear() {
      this.email = null;
      this.comments = null;
    },
    async sendContact() {
      this.loading = true;
      try {
        await System.contact(this.email, this.comments);
        await Notifications.alert('Thank you for contacting us. We will get back to you shortly');
        this.clear();
      } catch (e) {
        await Notifications.alert('An error occurred check console for details.');
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
  .contact-form {
    min-height: 60vh;
  }
</style>
